import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 3}px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 15;

  @media (min-width: 1025px) {
    align-items: flex-start;
    text-align: left;
    max-width: 1440px;
    margin: ${({ theme }) => theme.CONSTANTS.XH * 4}px 0 0 0;
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 25}px;
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  font-family: "Sora", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
    margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  }
`;

export const Description = styled.p`
  margin: ${({ theme }) => theme.CONSTANTS.XH * 0}px auto 0 auto;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  line-height: 1.6;
  font-family: "Inter", sans-serif;
  text-align: start;
  width: 88%;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 4}px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6.5}px;
    margin: 0;
    margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 6}px;
  }
`;

export const LinkInfo = styled.p`
  margin: ${({ theme }) => theme.CONSTANTS.XH * 1}px auto 0 auto;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  line-height: 1.6;
  font-family: "Inter", sans-serif;
  text-align: start;
  width: 88%;

  span {
    color: ${({ theme }) => theme.THEME.neonBlue};
    font-weight: 600;
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6.5}px;
    margin: ${({ theme }) => theme.CONSTANTS.XH * 2}px 0;
    width: 100%;
  }
`;

export const ItemsGrid = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 3}px;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 3}px;
  width: 86%;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 15;

  @media (min-width: 1025px) {
    width: 50%;
    margin-top: 0;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: ${({ theme }) => theme.CONSTANTS.XH * 2.5}px;
  }
`;

export const TextContent = styled.div`
  width: 100%;

  @media (min-width: 1025px) {
    width: 45%;
  }
`;
